var createReactClass = require('create-react-class');
import React from 'react';
import ViewableTable from './ViewableTable';
import AddFromExistingModal from './AddFromExistingModal';
import AddFromPmcModal from './AddFromPmcModal';
import UploadFileModal from './UploadFileModal';
import LockedTable from './LockedTable';
import Modal from '../Modal';
import Fluxxor from '../../../../../vendor/assets/javascripts/fluxxor';
import EmailTool from '../EmailTool';
import { Cureus } from '../../Cureus';

const ViewList = createReactClass({
  mixins: [
    Fluxxor.FluxMixin(React)
  ],

  getInitialState: function() {
    return {
      emailListRefreshes: this.props.emailListRefreshes,
      spinner: false
    }
  },

  handleAddFromExisting: function() {
    Modal.open({
      children: <AddFromExistingModal
                  options={this.props.addFromExistingOptions} />
    });
  },

  handleFileUploadClicked: function (evt){
    Modal.open({
      children: <UploadFileModal
                  updateListPath={this.props.updateListPath} />
    });
  },

  handleAddFromPmc: function() {
    Modal.open({
      children: <AddFromPmcModal createPmcListPath={this.props.createPmcListPath}/>
    })
  },

  search: function() {
    $.get(this.props.searchPath, function(data) {
      self.setState({
        judgeships: data,
      }, callback )
    }, "json")
  },

  deleteEmailListRefresh: function(destroyPath) {
    var self = this;
    if (window.confirm('Delete refresh source? This action is irreversible.')) {
      self.setState({ spinner: true });
      $.ajax({
        type: "DELETE",
        dataType: "json",
        url: destroyPath,
        success: function(data) {
          window.scrollTo({top: 0});
          Cureus.Flash.success("Refresh source removed from email list. Existing emails from this source will not be removed.");
          self.setState({ spinner: false, emailListRefreshes: data.emailListRefreshes });
        }
      })
    }
  },

  triggerEmailListRefresh: function(triggerPath) {
    var self = this;
    self.setState({ spinner: true });
    $.ajax({
      type: "POST",
      dataType: "json",
      url: triggerPath,
      success: function(data) {
        window.scrollTo({top: 0});
        Cureus.Flash.success("Email list queued for refreshing.");
        self.setState({ spinner: false, emailListRefreshes: data.emailListRefreshes });
      }
    })
  },

  handleRefresh: function() {
    var self = this;
    self.setState({ spinner: true })
    $.post(this.props.refreshPath, function(data) {
      window.location.href = window.location.href
    })
  },

  renderSpinner: function() {
    if (this.state.spinner) {
      return (
        <div className='spinner-container'>
          <img src='https://gallery.cureusjournals.com/collection/ajax-loader.gif'/>
        </div>
      )
    }
  },

  renderEmailListRefreshes: function() {
    var self = this;
    if (this.state.emailListRefreshes.length > 0) {
      var button = <a className='button' onClick={ self.handleRefresh } disabled= { this.state.spinner }>Refresh all</a>
      var header = <h3>Refresh Sources:</h3>
      var elements =  this.state.emailListRefreshes.map(function(item, idx) {
        return (
          <tr key={idx}>
            <td>{item.source}</td>
            <td dangerouslySetInnerHTML={{__html: item.params}}></td>
            <td>{item.state}</td>
            <td>{item.updated}</td>
            <td className='centered'>
              <div>
                <i className='fas fa-sync' style={{cursor: 'pointer'}} onClick={() => {self.triggerEmailListRefresh(item.triggerPath)}}></i>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                <i className='fas fa-trash' style={{cursor: 'pointer'}} onClick={() => {self.deleteEmailListRefresh(item.destroyPath)}}></i>
              </div>
            </td>
          </tr>
        )
      })
      return (
        <React.Fragment>
          { header }
          { button }
          { self.renderSpinner() }
          <table>
            <thead>
              <th>Source</th>
              <th>Info</th>
              <th>State</th>
              <th>Updated</th>
              <th>Actions</th>
            </thead>
            <tbody>
              {elements}
            </tbody>
          </table>
          <br/>
        </React.Fragment>
      )
    }
  },

  

  render: function() {
    if(this.props.disabled) {
      var content =
        <div className='no-subscribers-wrap'>
          <i className='far fa-envelope'></i>
          <h3>This list is currently being processed. The page will refresh when finished.</h3>
        </div>
    }else if(this.props.isLocked) {
      var content = <LockedTable dataSource={this.props.dataSource} title={this.props.title} columns={ this.props.columns} />
    }else if(this.props.listEmailsCount == 0) {
      var content =
        <div className='no-subscribers-wrap'>
          <i className='far fa-envelope'></i>
          <h3>This list has no subscribers.</h3>
          <p>
            <a className="email-list-upload-link" onClick={this.handleFileUploadClicked}>Upload a file</a>, <a onClick={this.handleAddFromExisting}>add from an existing list</a> or <a href={this.props.addFromCureusPath}>add from Cureus Users</a>
          </p>
        </div>
    } else {
      var content = <ViewableTable
                      dataSource={this.props.dataSource}
                      title={this.props.title}
                      deleteListEmailsPath={this.props.deleteListEmailsPath}
                      handleFileUpload={this.handleFileUploadClicked}
                      handleAddFromExisting={this.handleAddFromExisting}
                      addFromCureusPath={this.props.addFromCureusPath}
                      handleAddFromPmc={this.handleAddFromPmc}
                      className={this.props.className}
                      columns={ this.props.columns}
                    />
    }

    return (
      <div>
        {this.renderEmailListRefreshes()}
        <h3>View list</h3>
        {content}
      </div>
    )
  }
});

ViewList.defaultProps = {
  flux: new Fluxxor.Flux({
    Table: new EmailTool.fluxxor.stores.Table()
  }, EmailTool.fluxxor.actions)
}

export default ViewList;